import { render, staticRenderFns } from "./DistrubutiveUser.vue?vue&type=template&id=29546d1c&scoped=true&"
import script from "./DistrubutiveUser.vue?vue&type=script&lang=js&"
export * from "./DistrubutiveUser.vue?vue&type=script&lang=js&"
import style0 from "./DistrubutiveUser.vue?vue&type=style&index=0&id=29546d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29546d1c",
  null
  
)

export default component.exports